import * as yup from 'yup';
import { InferType } from 'yup';

const schemaVariable = yup.object({
  name: yup.string().default(''),
  value: yup.string().default(''),
});

export const schema = yup.object({
  toPhoneNumber: yup.string().required('rule-required').default(''),
  whatsAppContentID: yup.string().required('rule-required').default(''),
  variables: yup.array().of(schemaVariable).default([]),
});

export type FormModel = InferType<typeof schema>;